<template>
  <div class="left-list">
    <div class="header">
      <div class="header_title">就诊记录</div>
      <div v-if="hasMedicalRecord" @click="openSupplementMRecord" class="link-button">
        + 补充诊疗记录
      </div>
      <div v-else class="link-button link-button-disabled">+ 补充诊疗记录</div>
    </div>
    <div class="search-container">
      <div class="search-item">
        <a-select
          v-model:value="queryParam.consultType"
          placeholder="咨询方式"
          allowClear
          :options="inquiryTypeMap"
          style="width: 126px"
          @change="getList"
        />
      </div>
      <div class="search-item">
        <a-select
          v-model:value="queryParam.recomFlag"
          placeholder="处方状态"
          allowClear
          :options="prescriptionStatusMap"
          style="width: 98px"
          @change="getList"
        />
      </div>
    </div>
    <div class="list" ref="listDOM">
      <a-spin :spinning="loading">
        <div
          class="item"
          :class="{ 'item-check': item.isCheck }"
          v-for="(item, index) in list"
          :key="item.businessId"
          @click="handleItem(item.businessId)"
        >
          <div class="cell title">
            <div>{{ item.createTime }}</div>
            <!-- 类型 3-门诊 2-电话 1-视频 0-图文 -->
            <div
              class="title_tag"
              :class="`title_tag-${item.type}`"
              v-if="item.type === 3"
              color="green"
            >
              门诊就诊
            </div>
            <div
              class="title_tag"
              :class="`title_tag-${item.type}`"
              v-else-if="item.type === 2"
              color="rgba(255, 169, 64, 0.08)"
            >
              电话咨询
            </div>
            <div
              class="title_tag"
              :class="`title_tag-${item.type}`"
              v-else-if="item.type === 1"
              color="blue"
            >
              视频咨询
            </div>
            <div
              class="title_tag"
              :class="`title_tag-${item.type}`"
              v-else-if="item.type === 0"
              color="cyan"
            >
              图文咨询
            </div>
            <div class="title_tag" v-else color="blue">视频咨询</div>
            <div class="prescription-tag" v-if="item.recomFlag">处方</div>
          </div>
          <div class="cell" v-if="item.doctorName">
            <label class="label">问诊医生:</label>
            <span class="value">
              {{ item.doctorName }}
            </span>
          </div>
          <!-- 图文问诊 需要展示诊费 -->
          <div v-if="item.type === 0" class="cell">
            <label class="label">咨询费合计:</label>
            <span class="value">
              <template v-if="item.priceFree">{{ item.priceFree }}元</template>
              <template v-else>免费咨询</template>
            </span>
            <!-- 有明细才展示 -->
            <a-tooltip
              v-if="item.priceFreeOrder"
              :getPopupContainer="() => listDOM"
              color="#fff"
              placement="top"
            >
              <template #title>
                <div class="tooltip">
                  <div
                    class="tooltip_item"
                    v-for="(item, index) in item?.priceFreeOrder"
                    :key="item"
                  >
                    <div class="label">{{ index ? '续费' : '咨询费' }}:</div>
                    <div class="value">{{ item }}元</div>
                  </div>
                </div>
              </template>
              <QuestionCircleFilled class="icon" />
            </a-tooltip>
          </div>
          <!-- 视频问诊 -->
          <div v-else-if="[1].includes(item.type)" class="cell">
            <label class="label">服务项目:</label>
            <span class="value">{{ item.priceFree }}元 / {{ item.videoDuration }}分钟</span>
          </div>
          <!-- 电话咨询 -->
          <div v-else-if="[2].includes(item.type)" class="cell">
            <label class="label">服务项目:</label>
            <span class="value">{{ item.priceFree }}元 / {{ item.tcccDuration }}分钟</span>
          </div>
          <!-- 最后一行不展示 -->
          <div v-if="list.length !== ++index" class="divider-line"></div>
        </div>
        <EmptyText class="empty" v-if="list.length === 0" />
      </a-spin>
    </div>
    <MedicalRecordsPoup
      :visible="uploadRecordVisible"
      :params="{
        ucDoctorId: doctorInfo?.ucDoctorId,
        doctorId: doctorInfo?.doctorId,
        ucPatientId: info?.ucPatientId,
        patientId: info?.patientId
      }"
      :needAPI="true"
      :keepAlive="true"
      @savaData="savaData"
      @cancelClick="onClose"
      :communicateDoctor="false"
      :communicatePatient="false"
    ></MedicalRecordsPoup>
  </div>
</template>

<script setup>
import { diseaseCourseList } from '@/api/patientFile'
import EmptyText from '@/components/PatientFile/EmptyText.vue'
import MedicalRecordsPoup from '@/views/HealthRecord/HealthInfo/common/medicalRecordsPoup.vue'
import { QuestionCircleFilled } from '@ant-design/icons-vue'
import { watch } from 'vue'
import { computed, ref, defineEmits } from 'vue'
import { useStore } from 'vuex'
import {
  inquiryTypeMap,
  prescriptionStatusMap
} from '@/components/PatientFile/ModalBody/tags/RecordDisease/config'
const store = useStore()
const profileInfo = computed(() => store.state.patientFile.bindUser.profileInfo)
const doctorInfo = computed(() => store.state.patientFile.bindUser.doctorInfo)
const info = computed(() => store.state.patientFile.info)
const emits = defineEmits('refresh')
// 有id的情况
const hasMedicalRecord = computed(() => {
  let show = false
  const hasID = info.value.ucPatientId && info.value.patientId
  const hasDoc = doctorInfo.value.ucDoctorId && doctorInfo.value.doctorId
  show = !!hasID && !!hasDoc
  return show
})
const listDOM = ref()
const loading = ref(false)
const list = ref([])
const queryParam = {
  consultType: '',
  recomFlag: ''
}
// 选中的这个传入store中
const handleItem = businessId => {
  list.value.forEach(element => {
    element.isCheck = element.businessId === businessId
    // 选中某一个问诊
    if (element.businessId === businessId) {
      store.commit('patientFile/SET_DIAGNOSIS', { ...element })
    }
  })
}
const getList = () => {
  list.value = []
  const ucDoctorId = doctorInfo.value.ucDoctorId
  const ucPatientId = info.value.ucPatientId
  const patientProfileId = profileInfo.value.id
  const hasId = !!(ucDoctorId && ucPatientId)
  store.commit('patientFile/SET_DIAGNOSIS', {})
  if (!hasId) return
  const param = {
    ucDoctorId,
    ucPatientId,
    patientProfileId
  }
  // 过滤掉 queryParam 中的空值并合并到 query 对象
  Object.keys(queryParam).forEach(key => {
    const value = queryParam[key]
    if (value !== '' && value !== null && value !== undefined) {
      param[key] = value
    }
  })
  loading.value = true
  diseaseCourseList(param)
    .then(result => {
      list.value = result
      // 有数据的话默认 选中第一个
      if (list.value.length) {
        const businessId = list.value[0].businessId
        handleItem(businessId)
      }
    })
    .finally(() => {
      loading.value = false
    })
}
// 补充诊记录
const uploadRecordVisible = ref()
const openSupplementMRecord = () => {
  uploadRecordVisible.value = true
}

const onClose = () => {
  uploadRecordVisible.value = false
  getList()
  emits('refresh')
}
// 补充诊疗记录
const savaData = (type, data) => {
  uploadRecordVisible.value = false
  getList()
  emits('refresh')
}
watch(
  () => [doctorInfo.value.ucDoctorId, info.value.ucPatientId, profileInfo.value.id],
  () => {
    getList()
  },
  {
    immediate: true
  }
)
</script>

<style lang="scss" scoped>
.left-list {
  background: #f7fbff;
  height: 100%;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px;

    .header_title {
      color: #1c1c1c;
      font-size: 16px;
    }
    .link-button {
      border-radius: 4px;
      padding: 6px 12px;
      font-weight: 500;
      font-size: 14px;
      color: #1890ff;
      cursor: pointer;
      background: rgba(24, 144, 255, 0.15);
      &:hover {
        background: rgba(24, 144, 255, 0.25);
      }
    }
    .link-button-disabled {
      color: #cccccc;
      border-color: #eee;
      cursor: not-allowed;
    }
  }
  .search-container {
    padding: 0 10px 8px;
    .search-item {
      display: inline-block;
      margin-right: 12px;
      .search-input {
        width: 224px;
      }
    }
    &:last-child {
      margin-right: 0;
    }
  }
  .list {
    height: calc(100% - 140px);
    overflow: auto;
    ::v-deep(.ant-spin-nested-loading) {
      height: 100%;
      .ant-spin-container {
        height: 100%;
      }
    }
    .item {
      padding: 12px 15px 0;
      border: 1px solid transparent;
      cursor: pointer;
      border-radius: 4px;
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 12px;
        color: #999999;
        .prescription-tag {
          font-weight: 400;
          font-size: 10px;
          color: #3a3a3a;
          border-radius: 4px;
          background: #00000005;
          border: 1px solid #00000026;
          padding: 2px 4px;
        }
        .title_tag {
          font-weight: 400;
          font-size: 10px;
          padding: 2px 4px;
          border-radius: 2px;
          overflow: hidden;
        }
        // <!-- 类型 3-门诊 2-电话 1-视频 0-图文 -->
        .title_tag-0 {
          color: #00cec2;
          background: rgba(53, 201, 192, 0.08);
          border: 1px solid rgba(53, 201, 192, 0.2);
        }
        .title_tag-1 {
          color: #1677ff;
          background: #e6f4ff;
          border: 1px solid #bae0ff;
        }
        .title_tag-2 {
          color: #fd8b00;
          background: rgba(255, 169, 64, 0.08);
          border: 1px solid rgba(255, 169, 64, 0.2);
        }
        .title_tag-3 {
          background: rgba(82, 196, 26, 0.08);
          border: 1px solid rgba(82, 196, 26, 0.2);
          color: #52c41a;
        }
      }
      .cell {
        margin-bottom: 8px;
        font-weight: 400;
        font-size: 14px;
        .label {
          color: #666666;
          width: 85px;
          display: inline-block;
        }
        .value {
          color: #333333;
        }
        .icon {
          color: #cccccc;
          margin-left: 4px;
        }
      }
      .divider-line {
        margin-top: 12px;
        width: 100%;
        height: 1px;
        background: #edeff1;
      }
    }
    .item-check {
      background-color: rgba(24, 144, 255, 0.12);
      border-color: #1890ff;
    }
    ::v-deep(.ant-tooltip) {
      width: 160px;
      .ant-tooltip-inner {
        padding: 0;
        border-radius: 12px;
      }
      .tooltip {
        padding: 12px 24px;
        margin: 0;

        .tooltip_item {
          margin-bottom: 8px;
          display: flex;
          justify-content: space-between;
          &:last-child {
            margin-bottom: 0;
          }
          .label {
            font-size: 12px;
            color: #666666;
            position: relative;
            padding-left: 12px;
            &::before {
              content: '';
              position: absolute;
              width: 4px;
              height: 4px;
              background: #e5e5e5;
              border-radius: 50%;
              left: 2px;
              top: 0;
              bottom: 0;
              margin: auto;
            }
          }
          .value {
            font-weight: 500;
            font-size: 12px;
            color: #333333;
          }
        }
      }
    }
    .empty {
      padding: 32px 0;
    }
  }
}
</style>
